let notificationGlobalFn = null;

export function setNotifFunction(fn) {
  notificationGlobalFn = fn;
}

export function showNotificationG(msg) {
  if (notificationGlobalFn) {
    notificationGlobalFn(msg);
    setTimeout(() => notificationGlobalFn(null), 3000); // Auto-dismiss after 3 seconds
  } else {
    console.warn("Notification fn not set");
  }
}
